module.exports = __webpack_public_path__ + "img/open.8497b775.svg";